import { useCallback } from "react";

import { useLocale } from "../../../shared/i18n";
import {
  adminAuditMessages,
  type AdminAuditMessageKey,
} from "../../../shared/i18n/adminAuditMessages";
import { useShellT, type ShellKey } from "../useShellT";

export type AuditKey = ShellKey | AdminAuditMessageKey;
export type AuditTranslate = (key: AuditKey) => string;

function isAuditKey(key: string): key is AdminAuditMessageKey {
  return key in adminAuditMessages;
}

/** Looks in adminAuditMessages first, then the shell and shared catalogs. */
export function useAuditT(): AuditTranslate {
  const { locale } = useLocale();
  const shellT = useShellT();
  return useCallback(
    (key: AuditKey) =>
      isAuditKey(key) ? adminAuditMessages[key][locale] : shellT(key),
    [locale, shellT],
  );
}

/** Label for an event type; unknown types show the raw value. */
export function eventTypeLabel(t: AuditTranslate, type: string): string {
  const key = `admin.audit.type.${type}`;
  return isAuditKey(key) ? t(key) : type;
}
